import { Person, Topic, TopicExpertise } from "@shapeable/gesda-types";
import { useEditions } from "./use-editions";
import { maxBy, toNumber, toString } from 'lodash';
import { useCurrentEdition } from "./use-current-edition";

export const useCurrentEditionChairs = (committeeChairs: Person[], topic?: Topic) => {
  const currentYear = new Date().getFullYear();
  // const currentEdition = useCurrentEdition();
  const currentEdition = maxBy(topic?.editions, e => e.numericValue || toNumber(e.name));
  
  const memberChairsByEdition = committeeChairs.filter((member) => 
      (member.topicExpertise || []).some((expertise: TopicExpertise) =>
        expertise?.topic?.id === topic?.id &&
        expertise.editions.some(e => toString(e.name) === toString(currentEdition?.name || currentYear)))
    );
  return memberChairsByEdition;
  // return committeeChairs.filter(member => member.badge?.includes(toString(currentEdition?.name || currentYear)));
  
}